import React from "react";
import NavBar from "../components/navbar/NavBar";
import Error from "../components/404/Error";

function ErrorPage() {
  return (
    <>
      <NavBar active={"null"} />
      <Error />
    </>
  );
}

export default ErrorPage;
